// extracted by mini-css-extract-plugin
export var infoItem = "_su-2";
export var title = "_su-0";
export var value = "_su-1";